module.exports = __webpack_public_path__ + "img/bg_gangao@2x.336c84f4.png";